import { createFileRoute } from '@tanstack/react-router';
import { MetricsPage } from '@/pages/admin/system-monitor/metrics-page';

export const Route = createFileRoute(
  '/admin/_layout/system-monitor/_layout/metrics'
)({
  component: MetricsPage,
});
